import { Button, Text, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, FormControl, FormLabel, Input, Spinner, HStack } from '@chakra-ui/react'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { StorageService } from '../services/StorageService';
import { ErrorMessage } from '../components/ErrorMessage';
import { useOperation } from '../components/useOperation';

export const NewPageDialog = (props: {
  onClose: () => void;
}) => {

  const navigate = useNavigate();

  const [name, setName] = React.useState<string>('');

  const [execute, errorMessage, isProcessing] = useOperation(async () => {
      const fileName = `PAGE_${name}.md`;
      await StorageService.putTemplateFile(fileName, `# ${name}\n\nThis is a custom markdown page created by the user.`);
      navigate(`/admin/page/${fileName}`);
  }, [name]);

  const initialRef = React.useRef(null)

  return (
    <Modal
      initialFocusRef={initialRef}
      finalFocusRef={initialRef}
      size='xl'
      isOpen
      onClose={props.onClose}
      preserveScrollBarGap
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Create Custom Markdown Page</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>

          <ErrorMessage error={errorMessage} />

          <FormControl key='PageName' isRequired mt='4'>
            <FormLabel size='md'>Page Name</FormLabel>
            <Input
              ref={initialRef}
              placeholder='SOMETHING'
              value={name}
              style={{}}
              onChange={e => {
                const value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '_');
                setName(value);
              }}
            />
          </FormControl>
        </ModalBody>

        <ModalFooter>
          <Button variant='solid' isDisabled={!name} mr={4} onClick={execute}>
            <HStack spacing={2}>{isProcessing && <Spinner />}<Text>{isProcessing ? 'Creating...' : 'Create'}</Text></HStack>
          </Button>
          <Button variant='outline' onClick={props.onClose}>Cancel</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}